import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3402';

export interface AutoResponder {
  id: string;
  creatorId: string;
  name: string;
  triggerType: 'NEW_PATRON' | 'TIER_CHANGE' | 'ANNIVERSARY' | 'CUSTOM_DATE';
  tierIds?: string[];
  delayMinutes: number;
  subject: string;
  message: string;
  isActive: boolean;
  testMode: boolean;
  sentCount: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateAutoResponderData {
  name: string;
  triggerType: 'NEW_PATRON' | 'TIER_CHANGE' | 'ANNIVERSARY' | 'CUSTOM_DATE';
  tierIds?: string[];
  delayMinutes: number;
  subject: string;
  message: string;
  isActive: boolean;
  testMode?: boolean;
}

const autoResponderService = {
  // Create auto responder
  create: async (data: CreateAutoResponderData): Promise<AutoResponder> => {
    const response = await axios.post(`${API_URL}/api/auto-responders`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  },

  // Get all auto responders
  getAll: async (): Promise<AutoResponder[]> => {
    const response = await axios.get(`${API_URL}/api/auto-responders`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  },

  // Get single auto responder
  getById: async (id: string): Promise<AutoResponder> => {
    const response = await axios.get(`${API_URL}/api/auto-responders/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  },

  // Update auto responder
  update: async (id: string, data: Partial<CreateAutoResponderData>): Promise<AutoResponder> => {
    const response = await axios.patch(`${API_URL}/api/auto-responders/${id}`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  },

  // Toggle active status
  toggle: async (id: string): Promise<AutoResponder> => {
    const response = await axios.patch(
      `${API_URL}/api/auto-responders/${id}/toggle`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );
    return response.data;
  },

  // Delete auto responder
  delete: async (id: string): Promise<void> => {
    await axios.delete(`${API_URL}/api/auto-responders/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
  },

  // Test auto responder (send test message)
  test: async (id: string): Promise<{ success: boolean; message: string }> => {
    const response = await axios.post(
      `${API_URL}/api/auto-responders/${id}/test`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );
    return response.data;
  },
};

export default autoResponderService;
